import React, { useState } from 'react';
import { Steps, Button, message } from 'antd';
import {
  FileTextOutlined,
  ProfileOutlined,
  CloudUploadOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import W4Form from './W4Form';
import DirectDepositForm from './DirectDepositForm';
import Summary from './Summary';
import I9Form from './I9Form';
import { submitFormResonse, updateFormResonse } from '../../../api/dynamicForm';
import { useTranslation } from 'react-i18next';


const { Step } = Steps;


const formId = '68ca5503207ee155eac1e4bb';
const versionNumber = 1;

const Main = () => {
  const [current, setCurrent] = useState(0);
    const { id } = useParams();
      const { t } = useTranslation();
    

  const [formData, setFormData] = useState({
    "jobDetails&I9Section1": {},
    W4SectionDetails: {},
    bankDetails: {},
  });

  // Add esignature state
    const [esignature, setEsignature] = useState(null);

  const handleI9Change = (data) =>
    setFormData((prev) => ({
      ...prev,
      ["jobDetails&I9Section1"]: data,
    }));

  const handleW4Change = (data) =>
    setFormData((prev) => ({
      ...prev,
      W4SectionDetails: data,
    }));

  const handleDirectDepositChange = (data) =>
    setFormData((prev) => ({
      ...prev,
      bankDetails: data,
    }));

  const steps = [
    {
      title: 'I9 Form',
      icon: <FileTextOutlined style={{ fontSize: 22, color: '#1677ff' }} />,
      content: <I9Form value={formData["jobDetails&I9Section1"]} onChange={handleI9Change} />,
    },
    {
      title: 'W4 Form',
      icon: <ProfileOutlined style={{ fontSize: 22, color: '#1677ff' }} />,
      content: <W4Form value={formData.W4SectionDetails} onChange={handleW4Change} />,
    },
    {
      title: 'Direct Deposit Form',
      icon: <CloudUploadOutlined style={{ fontSize: 22, color: '#1677ff' }} />,
      content: <DirectDepositForm value={formData.bankDetails} onChange={handleDirectDepositChange} />,
    },
    {
      title: 'Summary',
      icon: <FileDoneOutlined style={{ fontSize: 22, color: '#1677ff' }} />,
      content: (
        <Summary
          data={formData}
          esignature={esignature}
          setEsignature={setEsignature}
        />
      ),
    },
  ];

  const next = () => setCurrent((c) => Math.min(c + 1, steps.length - 1));
  const prev = () => setCurrent((c) => Math.max(c - 1, 0));

  const handleFinish = async () => {
  const payload = {
    ...formData,
    signatureDetails: {
      acknowledged: !!esignature,
      signatureBase64: esignature || "",
    },
    id,
    formId,
    versionNumber,
  };

  try {
    let response;
    if (id) {
      response = await updateFormResonse(payload);
    } else {
      response = await submitFormResonse(payload);
    }
    message.success("Form submitted successfully!");


    // ✅ Reload the page after success
    setTimeout(() => {
      window.location.reload();
    }, 1000); // small delay so user sees success message

  } catch (err) {
    message.error("Error submitting form");
    console.error("Error submitting form:", err);
  }
};


  return (
    <div>
      <Steps current={current} style={{ marginBottom: 40 }} labelPlacement="vertical">
        {steps.map((item, idx) => (
          <Step
            key={item.title}
            title={item.title}
            icon={
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {item.icon}
                <span style={{ fontSize: 12, fontWeight: 'bold', marginTop: 4 }}>{idx + 1}</span>
              </div>
            }
          />
        ))}
      </Steps>

      <div style={{ minHeight: 320 }}>{steps[current].content}</div>

      <div style={{ textAlign: 'right', marginTop: 16 }}>
        <Button onClick={prev} disabled={current === 0} style={{ marginRight: 8 }}>
          {t('onboarding.previous')}
        </Button>
        {current === steps.length - 1 ? (
          <Button type="primary" onClick={handleFinish} disabled={!esignature}>
            {t('onboarding.submit')}
          </Button>
        ) : (
          <Button type="primary" onClick={next}>
            {t('onboarding.next')}          </Button>
        )}
      </div>
    </div>
  );
};

export default Main;
